import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import FullStory from 'react-fullstory';

class FullStoryContainer extends Component {
    render() {
        const orgId = get(this.props, 'config.env.REACT_APP_FULLSTORY_ORG_ID', null);
        return orgId ? (
            <FullStory org={orgId} />
        ) : null;
    }
}

const mapStateToProps = state => ({
    config: state.config
});

export default connect(mapStateToProps)(FullStoryContainer);



// WEBPACK FOOTER //
// ./src/containers/FullStoryContainer.js